import { StarIcon } from 'fitify-ui/src/Icon/fill/StarIcon'
import type { DataTypes } from 'fitify-ui-landing/src/@types'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import { StyledReview, StyledReviewStars, StyledText } from './Reviews.Styled'

const Review = ({ name, description }: DataTypes.ReviewItem) => {
  const { t } = useTranslation()

  return (
    <StyledReview>
      <Text as={'h3'} variant={'newsletter-title'} style={{ margin: 0 }}>
        {t(name)}
      </Text>
      <StyledReviewStars>
        <StarIcon color="Yellow400" />
        <StarIcon color="Yellow400" />
        <StarIcon color="Yellow400" />
        <StarIcon color="Yellow400" />
        <StarIcon color="Yellow400" />
      </StyledReviewStars>
      <StyledText>{t(description)}</StyledText>
    </StyledReview>
  )
}

export default Review
